<template>
  <v-card
    :color="cardColor"
    :style="`color: ${textColor}`"
    class="order-card"
    min-height="135px"
    height="fit-content"
  >
    <v-card-text class="order-card__content">
      <v-layout
        justify-space-between
        row
        class="ml-0 pl-0"
      >
        <v-flex
          xs7
          lg7
          class="ml-0 pl-0"
        >
          <b class="orderTitle"> Pedido: {{ order.id_erp }} </b>
        </v-flex>
        <v-flex
          xs5
          lg5
        >
          <!--  <v-chip
            v-if="order.purchase_order_status.name !== 'Concluído'"
            outline
            class="statusChip"
            color="black"
          >
            <span class="chipText">
              Pedido {{ order.purchase_order_status.name }}
            </span>
          </v-chip>

          <v-chip
            v-else
            color="#3D6961"
            text-color="white"
            class="statusChip"
          >
            <span class="chipText">
              Pedido {{ order.purchase_order_status.name }}
            </span>
          </v-chip> -->
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-text class="order-card__content">
      Realizado em: {{ formatDate(order.created_at) }}
      <br>
      Telefone do cliente: {{ formatPhoneNumber(order.client.cellphone) }}
      <br>
      Total da compra: {{ formatCurrency(order.total) }}
      <br>
      Vendedor: {{ order.seller_name }}
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    order: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters(['isManager', 'isDirector']),
    textColor() {
      return this.order.resolved ? '#8A8691' : '#140C22';
    },
    cardColor() {
      return this.order.resolved ? '#EEE' : '#FFF';
    },
    encodedId() {
      return btoa(this.order._id);
    },
  },

  methods: {
    formatPhoneNumber(phoneNumber) {
      const cleanedNumber = phoneNumber.replace(/\D/g, '');

      const countryCode = cleanedNumber.slice(0, 2);
      const areaCode = cleanedNumber.slice(2, 4);
      const firstPart = cleanedNumber.slice(4, 9);
      const secondPart = cleanedNumber.slice(9);

      return `+${countryCode} (${areaCode}) ${firstPart}-${secondPart}`;
    },

    formatDate(inputDate) {
      const date = new Date(inputDate);

      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    },

    formatCurrency(value) {
      const numericValue = parseFloat(value);

      if (isNaN(numericValue)) {
        return '';
      }

      const formattedValue = numericValue.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
      return formattedValue;
    },
  },
};
</script>

<style lang="scss" scoped>
.order-card {
  font-family: 'Nunito Sans';
  margin: 20px;
  padding: 20px;
  border-radius: 8px;
  &__title {
    font-weight: 700;
    display: flex;
    justify-content: space-between;
    padding: 0;
    font-size: 16px;
  }
  &__content {
    display: flex;
    justify-content: space-between;
    padding: 0;
    font-size: 14px;
  }
}

.orderTitle {
  font-size: 15px !important;
}

.statusChip {
  margin-top: -5px;
}

.chipText {
  font-size: 12px !important;
}

::v-deep .v-chip.v-chip.v-chip--outline {
  height: 28px !important
}
</style>
